<template>
  <div>
    <h3 class="h3-responsive">Нүүдэлчин гэрээ бүртгэлийн жагсаалт</h3>
    <Toast position="bottom-right" />

    <!-- configration dialog -->
    <Dialog
      header="Анхааруулга"
      :visible.sync="displayDelete"
      :style="{ width: '505px' }"
      :modal="true"
    >
      <template #header></template>
      <div class="confirmation-content">
        <i
          class="pi pi-exclamation-triangle p-mr-3"
          style="font-size: 2rem; margin-right: 0.5em; color: red"
        />
        <span
          >Та {{ this.contractId }} дугаартай гэрээг устгахдаа итгэлтэй байна уу
          ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          @click="actionDialog('no', null)"
          class="p-button-danger p-button-text"
        />
        <Button
          label="Тийм"
          icon="pi pi-check"
          @click="actionDialog('yes', null)"
          class="p-button-danger p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <!-- diaglog for register and update contract -->
    <Dialog
      :visible.sync="displayModal"
      :style="{ width: '70vw' }"
      :modal="true"
    >
      <template #header>
        <h3 class="h3-responsive">{{ modalTitle }}</h3>
        <div class="form-group">
          <label for="contractId">Гэрээний дугаар:</label>
          <InputText
            id="contractId"
            type="text"
            ref="contractInput"
            placeholder="Гэрээний дугаар №"
            class="form-control"
            v-model.trim="$v.contractId.$model"
            :class="{
              'is-invalid': $v.contractId.$error,
              'is-valid': !$v.contractId.$invalid,
            }"
            :disabled="contractDisabled == 1"
            :autofocus="IsFocus"
          />
          <div class="valid-feedback">Гэрээний дугаар оруулсан!</div>
          <div class="invalid-feedback">
            <span v-if="!$v.contractId.required"
              >Гэрээний дугаар оруулна уу.</span
            >
            <span v-if="!$v.contractId.minLength">
              Гэрээний дугаар доод тал нь
              {{ $v.contractId.$params.minLength.min }} тэмдэг байх ёстой.</span
            >
            <span v-if="!$v.contractId.maxLength">
              Гэрээний дугаар дээд тал нь
              {{ $v.contractId.$params.maxLength.max }} тэмдэг байх ёстой.</span
            >
            <span v-if="!$v.contractId.numeric"
              >Зөвхөн тоон утаг оруулна уу.</span
            >
          </div>
        </div>
      </template>

      <div class="p-grid nested-grid">
        <div class="p-col-4">
          <h5 class="h5-responsive">Хувийн мэдээлэл:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="parentsName">Эцэг/эх/-ийн нэр:</label>
              <InputText
                id="parentsName"
                type="text"
                class="form-control"
                v-model.trim="$v.parentsName.$model"
                :class="{
                  'is-invalid': $v.parentsName.$error,
                  'is-valid': !$v.parentsName.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">Эцэг/эх/-ийн нэр оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.parentsName.required">
                  Эцэг/эх/-ийн нэр оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="name">Өөрийн нэр:</label>
              <InputText
                id="name"
                type="text"
                v-model.trim="$v.name.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.name.$error,
                  'is-valid': !$v.name.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Өөрийн нэр оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.name.required">Өөрийн нэр оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6 offset-6">
              <label for="registerNumber">Регистрийн дугаар:</label>
              <InputText
                id="registerNumber"
                type="text"
                v-model.trim="$v.registerNumber.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.registerNumber.$error,
                  'is-valid': !$v.registerNumber.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Регистрийн дугаар оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.registerNumber.required"
                  >Регистрийн дугаар оруулна уу.</span
                >
                <span v-if="!$v.registerNumber.minLength">
                  Регистрийн дугаар доод тал нь
                  {{ $v.registerNumber.$params.minLength.min }} тэмдэг байх
                  ёстой.</span
                >
                <span v-if="!$v.registerNumber.maxLength">
                  Регистрийн дугаар дээд тал нь
                  {{ $v.registerNumber.$params.maxLength.max }} тэмдэг байх
                  ёстой.</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-6 p-offset-1">
          <h5 class="h5-responsive">Оршин суугаа хаяг:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="district">Дүүрэг:</label>
              <Dropdown
                v-model="selectedDistrict"
                :options="districtsItem"
                :filter="true"
                :showClear="true"
                optionLabel="name"
                placeholder="Дүүрэг сонгоно уу"
                :class="{
                  'is-invalid': $v.selectedDistrict.$error,
                  'is-valid': !$v.selectedDistrict.$invalid,
                }"
                :disabled="disabled == 1"
                @change="districtChange($event)"
              >
              </Dropdown>
              <div class="valid-feedback">Дүүрэг сонгоcон!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.selectedDistrict.required"
                  >Дүүрэг сонгоно уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="khoroo">Хороо:</label>
              <Dropdown
                v-model="selectedKhoroo"
                :options="khoroosItem"
                :filter="true"
                :showClear="true"
                optionLabel="name"
                placeholder="Хороо сонгоно уу"
                :class="{
                  'is-invalid': $v.selectedKhoroo.$error,
                  'is-valid': !$v.selectedKhoroo.$invalid,
                }"
                :disabled="disabled == 1 || isChoseDistrict"
              />
              <div class="valid-feedback">Хороо сонгоcон!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.selectedKhoroo.required"
                  >Хороо сонгоно уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="apartment">Хотхон:</label>
              <InputText
                id="apartment"
                type="text"
                v-model.trim="$v.apartment.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.apartment.$error,
                  'is-valid': !$v.apartment.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Хотхон оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.apartment.required">Хотхон оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="door">Байр/тоот:</label>
              <InputText
                id="door"
                type="text"
                v-model.trim="$v.door.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.door.$error,
                  'is-valid': !$v.door.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Байр/тоот оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.door.required">Байр/тоот оруулна уу.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-4">
          <h5 class="h5-responsive">Ажил эрхлэлт:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="workPlace">Ажилын газар:</label>
              <InputText
                id="workPlace"
                type="text"
                v-model.trim="$v.workPlace.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.workPlace.$error,
                  'is-valid': !$v.workPlace.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Ажилын газар оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.workPlace.required"
                  >Ажилын газар оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="position">Албан тушаал:</label>
              <InputText
                id="position"
                type="text"
                v-model.trim="$v.position.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.position.$error,
                  'is-valid': !$v.position.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Албан тушаал оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.position.required"
                  >Албан тушаал оруулна уу.</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-6 p-offset-1">
          <h5 class="h5-responsive">Бүртгэлтэй дугаар:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="phoneNumber">Утас 1:</label>
              <InputText
                id="phoneNumber"
                type="text"
                v-model.trim="$v.phoneNumber.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.phoneNumber.$error,
                  'is-valid': !$v.phoneNumber.$invalid,
                }"
                :disabled="disabled == 1"
                placeholder="99999999"
              />
              <div class="valid-feedback">Утас 1 оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.phoneNumber.required">Утас 1 оруулна уу.</span>
                <span v-if="!$v.phoneNumber.maxLength">
                  Утасны дугаар дээд тал нь
                  {{ $v.phoneNumber.$params.maxLength.max }} тэмдэг байх
                  ёстой.</span
                >
                <span v-if="!$v.phoneNumber.numeric"
                  >Зөвхөн тоон утаг оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6">
              <label for="phoneNumber2">Утас 2:</label>
              <InputText
                id="phoneNumber2"
                type="text"
                v-model.trim="$v.phoneNumber2.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.phoneNumber2.$error,
                  'is-valid': !$v.phoneNumber2.$invalid,
                }"
                :disabled="disabled == 1"
                placeholder="99999999"
              />
              <div class="valid-feedback">Утас 2 оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.phoneNumber2.required">Утас 2 оруулна уу.</span>
                <span v-if="!$v.phoneNumber2.maxLength">
                  Утасны дугаар дээд тал нь
                  {{ $v.phoneNumber2.$params.maxLength.max }} тэмдэг байх
                  ёстой.</span
                >
                <span v-if="!$v.phoneNumber2.numeric"
                  >Зөвхөн тоон утаг оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-6 offset-6">
              <label for="email">Э-шуудан:</label>
              <InputText
                id="email"
                type="text"
                v-model.trim="$v.email.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.email.$error,
                  'is-valid': !$v.email.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Э-шуудан оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.email.required">Э-шуудан оруулна уу.</span>
                <span v-if="!$v.email.email"
                  >Э-шуудангын форматыг зөв оруулна уу. / @gmail.com, @yahoo.com
                  /
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-12">
          <h5 class="h5-responsive">Яаралтай үед холбоо барих:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-2">
              <label for="relateWho">Таны хэн болох:</label>
              <InputText
                id="relateWho"
                type="text"
                v-model.trim="$v.relateWho.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.relateWho.$error,
                  'is-valid': !$v.relateWho.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Таны хэн болох оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.relateWho.required"
                  >Таны хэн болох оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-2">
              <label for="relateName">Овог нэр:</label>
              <InputText
                id="relateName"
                type="text"
                v-model.trim="$v.relateName.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.relateName.$error,
                  'is-valid': !$v.relateName.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Овог нэр оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.relateName.required">Овог нэр оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-2 offset-1">
              <label for="relateRegisterNumber">Регистрийн дугаар:</label>
              <InputText
                id="relateRegisterNumber"
                type="text"
                v-model.trim="$v.relateRegisterNumber.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.relateRegisterNumber.$error,
                  'is-valid': !$v.relateRegisterNumber.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Регистрийн дугаар оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.relateRegisterNumber.required"
                  >Регистрийн дугаар оруулна уу.</span
                >
                <span v-if="!$v.relateRegisterNumber.minLength">
                  Регистрийн дугаар доод тал нь
                  {{ $v.relateRegisterNumber.$params.minLength.min }} тэмдэг
                  байх ёстой.</span
                >
                <span v-if="!$v.relateRegisterNumber.maxLength">
                  Регистрийн дугаар дээд тал нь
                  {{ $v.relateRegisterNumber.$params.maxLength.max }} тэмдэг
                  байх ёстой.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-2">
              <label for="relatePhoneNumber">Утасны дугаар:</label>
              <InputText
                id="relatePhoneNumber"
                type="text"
                v-model.trim="$v.relatePhoneNumber.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.relatePhoneNumber.$error,
                  'is-valid': !$v.relatePhoneNumber.$invalid,
                }"
                :disabled="disabled == 1"
                placeholder="99999999"
              />
              <div class="valid-feedback">Утасны дугаар оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.relatePhoneNumber.required"
                  >Утасны дугаар оруулна уу.</span
                >
                <span v-if="!$v.relatePhoneNumber.maxLength">
                  Утасны дугаар дээд тал нь
                  {{ $v.relatePhoneNumber.$params.maxLength.max }} тэмдэг байх
                  ёстой.</span
                >
                <span v-if="!$v.relatePhoneNumber.numeric"
                  >Зөвхөн тоон утаг оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-2">
              <label for="relateEmail">Э-шуудан:</label>
              <InputText
                id="relateEmail"
                type="text"
                v-model.trim="$v.relateEmail.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.relateEmail.$error,
                  'is-valid': !$v.relateEmail.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Э-шуудан оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.relateEmail.required"
                  >Э-шуудан оруулна уу.</span
                >
                <span v-if="!$v.relateEmail.email"
                  >Э-шуудангын форматыг зөв оруулна уу. / @gmail.com, @yahoo.com
                  /</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-6">
          <h5 class="h5-responsive">Билл цикл эхлэх огноо:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-12">
              <Calendar
                id="billCycleDate"
                v-model.trim="$v.billCycleDate.$model"
                :disabled="disabled == 1"
                :class="{
                  'is-invalid': $v.billCycleDate.$error,
                  'is-valid': !$v.billCycleDate.$invalid,
                }"
              />
              <div class="valid-feedback">Билл цикл огноог оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.billCycleDate.required"
                  >Билл цикл огноо оруулна уу.</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-6">
          <h5 class="h5-responsive">Багцын сонголт:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-12">
              <Dropdown
                v-model="selectedPackage"
                :options="packagesItem"
                optionLabel="Label"
                placeholder="Багц сонгоно уу"
                :class="{
                  'is-invalid': $v.selectedPackage.$error,
                  'is-valid': !$v.selectedPackage.$invalid,
                }"
                :disabled="disabled == 1"
              />
              <div class="valid-feedback">Багц сонгосон!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.selectedPackage.required"
                  >Багц сонгоно уу.</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-4">
          <h5 class="h5-responsive">Захиалгат үйлчилгээ:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-12">
              <Dropdown
                v-model="selectedOrder"
                :options="orderServicesItem"
                placeholder="Захиалгат үйлчилгээ сонгох"
                optionLabel="Label"
                :disabled="disabled == 1"
              />
            </div>
          </div>
        </div>
        <div class="p-col-4">
          <h5 class="h5-responsive">Тоног төхөөрөмж:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-12">
              <Dropdown
                v-model.trim="$v.selectedProduct.$model"
                :options="productsItem"
                optionLabel="name"
                placeholder="Тоног төхөөрөмж сонгоно уу"
                :class="{
                  'is-invalid': $v.selectedProduct.$error,
                  'is-valid': !$v.selectedProduct.$invalid,
                }"
                :disabled="disabled == 1"
                @change="productChange($event)"
              />
              <div class="valid-feedback">Тоног төхөөрөмж сонгосон!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.selectedProduct.required"
                  >Тоног төхөөрөмж сонгоно уу.</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-4">
          <h5 class="h5-responsive">Дугаарын сонголт:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-12">
              <MultiSelect
                v-model="selectedNumbers"
                :options="numbers"
                optionLabel="name"
                placeholder="Дугаар сонгоно уу"
                :disabled="disabled == 1"
              />
            </div>
          </div>
        </div>
        <div v-show="isSelectedProduct">
          <div class="p-col-12">
            <h5>Тоног төхөөрөмжийн жагсаалт</h5>
            <BlockUI :blocked="blockedTable">
              <DataTable
                :value="productsChildrenItem"
                editMode="cell"
                class="editable-cells-table"
              >
                <Column field="Name" header="Нэр"> </Column>
                <Column field="MeasureId" header="Хэмжих нэгж"> </Column>
                <Column field="Quantity" header="Тоо ширхэг">
                  <template #editor="slotProps">
                    <div class="form-group">
                      <InputText
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </div>
                  </template>
                </Column>
                <Column field="SerialId" header="Сериал дугаар">
                  <template #editor="slotProps">
                    <InputText
                      v-model="slotProps.data[slotProps.column.field]"
                    />
                  </template>
                </Column>
                <Column field="Description" header="Тайлбар">
                  <template #editor="slotProps">
                    <InputText
                      v-model="slotProps.data[slotProps.column.field]"
                    />
                  </template>
                </Column>
              </DataTable>
            </BlockUI>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          class="p-button-danger p-button-text"
          @click="actionModal('no', null)"
        />
        <Button
          label="Хадгалах"
          type="submit"
          icon="pi pi-save"
          class="p-button-success"
          @click="actionModal('save', null)"
          v-show="!viewMode && !viewEdit"
        />
        <Button
          label="Шинэчлэх"
          icon="pi pi-save"
          class="p-button-warning"
          @click="actionModal('update', null)"
          v-show="viewEdit"
          :autofocus="viewEdit"
        />
        <Button
          label="Хэвлэх"
          icon="pi pi-file"
          @click="actionModal('print', null)"
          v-show="viewMode"
          :autofocus="viewMode"
        />
      </template>
    </Dialog>
    <DataTable
      :value="contracts"
      :filters="filters"
      :paginator="true"
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20]"
      :loading="loading"
      class="p-datatable-sm"
    >
      <template #header>
        <div class="p-grid">
          <div class="p-col">
            <div class="box">
              <Button
                label="Бүртгэл"
                class="p-button-success"
                icon="pi pi-plus"
                style="margin: 4px 4px 0px 0px"
                @click="actionModal('new', null)"
              />
            </div>
          </div>
          <div class="p-col" style="text-align: right">
            <div class="box">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  placeholder="Хайлт...."
                  size="40"
                  v-model="filters['global']"
                />
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #empty>Гэрээ олдсонгүй.</template>
      <template #loading
        >Гэрээний мэдээллийг ачаалж байна. Түр хүлээнэ үү.</template
      >
      <Column selectionMode="single" headerStyle="width: 3em"></Column>
      <Column field="Id" header="Гэрээний №" headerStyle="width: 10em">
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.Id }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['Id']"
              class="p-column-filter p-inputtext-sm"
              placeholder="ID-гаар хайх"
              style="width: 10em"
            />
          </div>
        </template>
      </Column>
      <Column field="Name" header="Нэр" headerStyle="width: 10em">
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.Name }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['Name']"
            class="p-column-filter p-inputtext-sm"
            placeholder="Нэрээр хайх"
            style="width: 10em"
          />
        </template>
      </Column>
      <Column
        field="RegisterNumber"
        header="Регистрийн №"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{
            slotProps.data.RegisterNumber
          }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['RegisterNumber']"
            class="p-column-filter p-inputtext-sm"
            placeholder="Регистрээр хайх"
            style="width: 10em"
          />
        </template>
      </Column>
      <Column field="PhoneNumber" header="Утас" headerStyle="width: 10em">
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.PhoneNumber }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['PhoneNumber']"
            class="p-column-filter p-inputtext-sm"
            placeholder="Утасаар хайх"
            style="width: 10em"
          />
        </template>
      </Column>
      <Column field="Email" header="N-мэйл" headerStyle="width: 10em">
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.Email }}</span>
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['Email']"
            class="p-column-filter p-inputtext-sm"
            placeholder="N-мэйлээр хайх"
            style="width: 10em"
          />
        </template>
      </Column>
      <Column field="Status" header="Статус">
        <template #body="slotProps">
          <Button
            icon="pi pi-times"
            class="p-button-rounded p-button-success p-button-text"
            style="margin-right: 0.5em"
            v-if="slotProps.data.Status == 'expired'"
          ></Button>
          <Button
            icon="pi pi-check"
            class="p-button-rounded p-button-danger p-button-text"
            style="margin-right: 0.5em"
            v-if="slotProps.data.Status == 'normal'"
          ></Button>
        </template>
      </Column>
      <Column
        headerStyle="width: 25em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #header>
          <Button type="button" icon="pi pi-cog"></Button> </template
        >,
        <template #body="slotProps">
          <Button
            label="харах"
            type="button"
            icon="pi pi-eye"
            class="p-button-primery"
            style="margin-right: 0.5em"
            @click="actionModal('view', slotProps.data)"
          ></Button>
          <Button
            label="засах"
            type="button"
            icon="pi pi-pencil"
            class="p-button-warning"
            style="margin-right: 0.5em"
            @click="actionModal('edit', slotProps.data)"
          ></Button>
          <Button
            label="устгах"
            type="button"
            icon="pi pi-trash"
            class="p-button-danger"
            @click="actionDialog('open', slotProps.data.Id)"
          ></Button>
        </template>
      </Column>
      <template #footer
        >Нийт {{ contracts ? contracts.length : 0 }} гэрээ байна.</template
      >
    </DataTable>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toast from "primevue/toast";
import Dialog from "primevue/dialog";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import BlockUI from 'primevue/blockui';
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
} from "vuelidate/lib/validators";

const baseURL = "http://localhost:8080/contract";

export default {
  name: "FormValidation",
  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Toast,
    Dialog,
    Calendar,
    Dropdown,
    MultiSelect,
    BlockUI
  },
  data() {
    return {
      maxId: "",
      contractId: "",
      modalTitle: "",
      contracts: [],
      errors: [],
      filters: {},
      loading: true,
      displayDelete: false,
      displayModal: false,
      viewMode: false,
      viewEdit: false,
      billCycleDate: null,
      name: "",
      parentsName: "",
      registerNumber: "",
      selectedDistrict: null,
      selectedKhoroo: null,
      apartment: "",
      door: "",
      workPlace: "",
      position: "",
      phoneNumber: "",
      phoneNumber2: "",
      email: "",
      relateWho: "",
      relateName: "",
      relateEmail: "",
      relateRegisterNumber: "",
      relatePhoneNumber: "",
      selectedPackage: null,
      selectedOrder: null,
      selectedProduct: null,
      selectedNumbers: null,
      contractDisabled: 0,
      disabled: 0,
      IsFocus: false,
      IsParents: false,
      open: false,
      districtsItem: [
        { name: "Багануур", value: "Baganuur", districtId: "1" },
        { name: "Багахангай", value: "BagaKhangai", districtId: "2" },
        { name: "Баянгол", value: "Bayngol", districtId: "3" },
        { name: "Баянзүрх", value: "Baynzurkh", districtId: "4" },
        { name: "Налайх", value: "Nalaikh", districtId: "5" },
        { name: "Сонгинохайрхан", value: "SonginKhairkan", districtId: "6" },
        { name: "Сүхбаатар", value: "SvkhBaatar", districtId: "7" },
        { name: "Хан-Уул", value: "Khan-Uul", districtId: "8" },
        { name: "Чингэлтэй", value: "Chingeltei", districtId: "9" },
      ],
      defualtkhoroos: [
        {
          name: "1-р хороо",
          value: "1",
          districtId: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "2-р хороо",
          value: "2",
          districtId: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "3-р хороо",
          value: "3",
          districtId: ["1", "3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "4 р хороо",
          value: "4",
          districtId: ["1", "3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "5-р хороо",
          value: "5",
          districtId: ["1", "3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "6-р хороо",
          value: "6",
          districtId: ["3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "7-р хороо",
          value: "7",
          districtId: ["3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "8-р хороо",
          value: "8",
          districtId: ["3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "9 р хороо",
          value: "9",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "10-р хороо",
          value: "10",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "11-р хороо",
          value: "11",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "12-р хороо",
          value: "12",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "13-р хороо",
          value: "13",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "14-р хороо",
          value: "14",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "15-р хороо",
          value: "15",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "16-р хороо",
          value: "16",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "17-р хороо",
          value: "17",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "18-р хороо",
          value: "18",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "19-р хороо",
          value: "19",
          districtId: ["3", "4", "6", "7", "8", "9"],
        },
        {
          name: "20-р хороо",
          value: "20",
          districtId: ["3", "4", "6", "7", "8"],
        },
        { name: "21-р хороо", value: "21", districtId: ["3", "4", "6", "8"] },
        { name: "22-р хороо", value: "22", districtId: ["3", "4", "6"] },
        { name: "23-р хороо", value: "23", districtId: ["3", "4", "6"] },
        { name: "24 р хороо", value: "24", districtId: ["3", "4", "6"] },
        { name: "25-р хороо", value: "25", districtId: ["4", "6"] },
        { name: "26-р хороо", value: "26", districtId: ["4", "6"] },
        { name: "27-р хороо", value: "27", districtId: ["4", "6"] },
        { name: "28-р хороо", value: "28", districtId: ["4", "6"] },
        { name: "29-р хороо", value: "29", districtId: ["4", "6"] },
        { name: "30-р хороо", value: "30", districtId: ["4", "6"] },
        { name: "31-р хороо", value: "31", districtId: ["6"] },
        { name: "32-р хороо", value: "32", districtId: ["6"] },
        { name: "33-р хороо", value: "33", districtId: ["6"] },
        { name: "34-р хороо", value: "34", districtId: ["6"] },
        { name: "35-р хороо", value: "35", districtId: ["6"] },
        { name: "36-р хороо", value: "36", districtId: ["6"] },
        { name: "37-р хороо", value: "37", districtId: ["6"] },
        { name: "38-р хороо", value: "38", districtId: ["6"] },
        { name: "39-р хороо", value: "39", districtId: ["6"] },
        { name: "40-р хороо", value: "40", districtId: ["6"] },
        { name: "41-р хороо", value: "41", districtId: ["6"] },
        { name: "42-р хороо", value: "42", districtId: ["6"] },
        { name: "43-р хороо", value: "43", districtId: ["6"] },
      ],
      khoroosItem: null,
      numbers: [
        { name: "7100xxxx, Энгийн дугаар", value: "normal" },
        { name: "7100ABAB, Хүрэл дугаар", value: "bronze" },
        { name: "7100AABB, Мөнгөн дугаар", value: "silver" },
        { name: "7100AAAA, Алтан дугаар", value: "gold" },
      ],
      packagesItem: [],
      productsItem: [
        { name: "Интернэт+Телезиз+Утас /Багц төхөөрөмж/", type: "Package" },
        { name: "Интернэт+Телезиз", type: "TV" },
        { name: "Интернэт+Утас", type: "Phone" },
        { name: "Интернэт+Wireless", type: "WireLess" },
        { name: "Интернэт", type: "Internet" },
      ],
      childrenItem: [
        {
          Name: "SkyEdgeII-c Gemini-e VSAT modem",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "0.75м хиймэл дагуулын антенна",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "TВ хүлээн авагч",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "TV",
          ContractId: this.contractId,
        },
        {
          Name: "IP утас",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Phone",
          ContractId: this.contractId,
        },
        {
          Name: "TP-Link Wireless router",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "WireLess",
          ContractId: this.contractId,
        },
        {
          Name: "Салаалагч /2той/",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "LNB KU-Band",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "BUC KU-4W",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "Feed Horn",
          Amount: 0,
          Quantity: "1",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "Кабель",
          Amount: 0,
          Quantity: "36",
          MeasureId: "м",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
        {
          Name: "Коннектор",
          Amount: 0,
          Quantity: "4",
          MeasureId: "ш",
          Description: "",
          SerialId: "",
          Type: "Internet",
          ContractId: this.contractId,
        },
      ],
      contractProducts: [],
      productsChildrenItem: null,
      isChoseDistrict: true,
      isSelectedProduct: false,
      editingRows: [],
      originalRows: null,
      orderServicesItem: [],
      blockedTable: false
    };
  },
  validations: {
    contractId: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(8),
    },
    name: {
      required,
    },
    parentsName: {
      required,
    },
    registerNumber: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(10),
    },
    selectedDistrict: {
      required,
    },
    selectedKhoroo: {
      required,
    },
    apartment: {
      required,
    },
    door: {
      required,
    },
    workPlace: {
      required,
    },
    position: {
      required,
    },
    phoneNumber: {
      required,
      numeric,
      maxLength: maxLength(8),
    },
    phoneNumber2: {
      required,
      numeric,
      maxLength: maxLength(8),
    },
    email: {
      email,
      required,
    },
    relateWho: {
      required,
    },
    relateName: {
      required,
    },
    relateEmail: {
      email,
      required,
    },
    relateRegisterNumber: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(10),
    },
    relatePhoneNumber: {
      required,
      numeric,
      maxLength: maxLength(8),
    },
    selectedPackage: {
      required,
    },
    selectedProduct: {
      required,
    },
    billCycleDate: {
      required,
    },
  },

  async created() {
    try {
      const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted
      const requestTwo = axios.get(baseURL + "/maxId"); //get maxId
      const requestThird = axios.get("http://localhost:8080/package");
      const requestFourth = axios.get("http://localhost:8080/orderService");
      const requestFifth = axios.get("http://localhost:8080/product");

      await axios
        .all([requestOne, requestTwo, requestThird, requestFourth, requestFifth])
        .then(
          axios.spread((...responses) => {
            const responseOne = responses[0];
            const responseTwo = responses[1];
            const responseThird = responses[2];
            const responseFourth = responses[3];
            const responseFifth = responses[4];
            // use/access the results
            this.contracts = responseOne.data;
            this.maxId = responseTwo.data;
            this.contractProducts = responseFifth.data;
            
            //add label option for package->
            responseThird.data.forEach((element) => {
              this.packagesItem.push({
                Label:
                  "Төрөл:" +
                  element.Type +
                  " ," +
                  "Дата:" +
                  element.Data +
                  "GB ," +
                  "Нэгж:" +
                  element.Unit +
                  "," +
                  "Сарын төлөлт:" +
                  element.MonthlyPayment +
                  "₮",
                Id: element.Id,
              });
            });

            //add label option for ->
            responseFourth.data.forEach((order) => {
              this.orderServicesItem.push({
                Label:
                  "Төрөл:" +
                  order.Type +
                  "," +
                  "Үнийн дүн:" +
                  order.Price +
                  "₮",
                Id: order.Id,
              });
            });
          })
        )
        .catch((errors) => {
          console.log(errors);
        });

      //console.log(this.packagesItem);
      this.loading = false;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    productChange(event) {
      this.isSelectedProduct = true;
      this.productsChildrenItem = this.childrenItem;
      const contractId = this.contractId;
      const value = event.value.type;
      switch (value) {
        case "TV":
          this.productsChildrenItem = this.productsChildrenItem.filter(
            function (item) {
              item.ContractId = contractId;
              return !item.Type.match("Phone") && !item.Type.match("WireLess");
            }
          );
          break;
        case "Phone":
          this.productsChildrenItem = this.productsChildrenItem.filter(
            function (item) {
              item.ContractId = contractId;
              return !item.Type.match("TV") && !item.Type.match("WireLess");
            }
          );

          break;
        case "WireLess":
          this.productsChildrenItem = this.productsChildrenItem.filter(
            function (item) {
              item.ContractId = contractId;
              return !item.Type.match("TV") && !item.Type.match("Phone");
            }
          );

          break;
        case "Internet":
          this.productsChildrenItem = this.productsChildrenItem.filter(
            function (item) {
              item.ContractId = contractId;
              return (
                !item.Type.match("Phone") &&
                !item.Type.match("WireLess") &&
                !item.Type.match("TV")
              );
            }
          );
          break;
        default:
          this.productsChildrenItem = this.productsChildrenItem.forEach(
            (item) => {
              item.ContractId = contractId;
            }
          );
          break;
      }
    },
    districtChange(event) {
      this.isChoseDistrict = false;
      if (event != null && this.selectedDistrict != null) {
        const Id = event.value.districtId;
        this.selectedDistrict = event.value;
        this.khoroosItem = this.defualtkhoroos;
        this.khoroosItem = this.khoroosItem.filter(function (value) {
          return value.districtId.includes(Id);
        });
      } else this.selectedKhoroo = null;
    },
    async actionDialog(condition, id) {
      if (condition == "open") {
        this.contractId = id;
        this.displayDelete = true;
      } else {
        if (condition == "yes") {
          // delete contract by Id && delete product by contractId
          const resContract = axios.delete(baseURL + "/" + this.contractId);
          const resProduct = axios.delete("http://localhost:8080/product/multi/" + this.contractId)
                 
          const results = await axios.all([resContract, resProduct]).catch((errors) => { console.log(errors); });

          if(results[0].status == 200 && results[1].status == 200)
          {
              const resData = await axios.get(baseURL).catch((error) => { console.log(error); });          
              this.contracts = resData.data;
              this.$toast.add({
                severity: "error",  
                summary: "Амжилттай устгасан",
                detail: "" + this.contractId + "",
                life: 3000,
              }); 

          }                 
        }
        this.displayDelete = false;
      }
    },
    async actionModal(type, data) {
      if (type == "new") {
        //add new Contract to the database
        if (this.maxId == null) this.IsFocus = true;
        else this.IsParents = true;
        this.isSelectedProduct = false;
        this.contractId = "000" + (+this.maxId + +"1");
        this.contractDisabled = 0;
        this.disabled = 0;
        this.modalTitle = "Гэрээ бүртгэлийн горим";
        this.displayModal = true;
        this.viewEdit = false;
        this.viewMode = false;
        this.billCycleDate = null;
        this.name = "";
        this.parentsName = "";
        this.registerNumber = "";
        this.selectedDistrict = null;
        this.selectedKhoroo = null;
        this.apartment = "";
        this.door = "";
        this.workPlace = "";
        this.position = "";
        this.phoneNumber = "";
        this.phoneNumber2 = "";
        this.email = "";
        this.relateWho = "";
        this.relateName = "";
        this.relateEmail = "";
        this.relateRegisterNumber = "";
        this.relatePhoneNumber = "";
        this.selectedPackage = null;
        this.selectedOrder = null;
        this.selectedProduct = null;
        this.selectedNumbers = null;
        this.isChoseDistrict = true;
      } else if (type == "save") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        }
        //check contractId whether exist in database or not
        else if (this.contractId != null) {
          // check existing contract id
          const res = await axios.get(baseURL + "/checkId/" + this.contractId);
          if (res.data.length >= 1) {
            this.$toast.add({
              severity: "warn",
              summary: "Гэрээний дугаарыг өөрчилнө үү.",
              detail:
                "" +
                this.contractId +
                " дугаартай гэрээ аль хэдийн бүртгэгдсэн байна !",
              life: 3000,
            });
            this.IsFocus = true;
          } else {
            const reqContract = axios.post(baseURL + "/add", {
              contractId: this.contractId,
              name: this.name,
              parentsName: this.parentsName,
              registerNumber: this.registerNumber,
              district: this.selectedDistrict.value,
              khoroo: this.selectedKhoroo.value,
              apartment: this.apartment,
              door: this.door,
              workPlace: this.workPlace,
              position: this.position,
              phoneNumber: this.phoneNumber,
              phoneNumber2: this.phoneNumber2,
              email: this.email,
              relateWho: this.relateWho,
              relateName: this.relateName,
              relateEmail: this.relateEmail,
              relateRegisterNumber: this.relateRegisterNumber,
              relatePhoneNumber: this.relatePhoneNumber,
              packageId: this.selectedPackage.Id,
              orderServiceId: this.selectedOrder.Id,
              productType: this.selectedProduct.type,
              productPackage: this.productsChildrenItem,
            }); 
            
            
            Date.prototype.addDays = function(days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
            }

            const reqBill = axios.post("http://localhost:8080/billcycle" + "/add", {
              startDate: this.billCycleDate,
              endDate: this.billCycleDate.addDays(7),
              amount: 0,
              contractId: this.contractId
            });
             
            await axios
            .all([reqContract, reqBill])
            .then(
              axios.spread((...responses) => {
                 const responseContract = responses[0];
                 const responseBill = responses[1];

                   if(responseContract.status == 200 && responseBill.status == 200)
                   {
                     const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted
                     const requestTwo = axios.get(baseURL + "/maxId"); //get maxId

                       axios
                        .all([requestOne, requestTwo])
                        .then(
                          axios.spread((...responses) => {
                            const responseOne = responses[0];
                            const responseTwo = responses[1];
                            // use/access the results
                            this.contracts = responseOne.data;
                            this.maxId = responseTwo.data;
                          })
                        )
                        .catch((errors) => {
                          console.log(errors);
                        });
                      this.modal = false;
                      this.displayModal = false;
                      this.viewMode = false;
                      this.$toast.add({
                        severity: "success",
                        summary: "Амжилттай хадгалагдсан",
                        detail: "",
                        life: 3000,
                      });

                   }    
              })
            )
            .catch((errors) => {
               console.log(errors);
            }); 
                            
            // if (res.status == 200) {
            //   const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted
            //   const requestTwo = axios.get(baseURL + "/maxId"); //get maxId

            //   await axios
            //     .all([requestOne, requestTwo])
            //     .then(
            //       axios.spread((...responses) => {
            //         const responseOne = responses[0];
            //         const responseTwo = responses[1];
            //         // use/access the results
            //         this.contracts = responseOne.data;
            //         this.maxId = responseTwo.data;
            //       })
            //     )
            //     .catch((errors) => {
            //       console.log(errors);
            //     });
            //   this.modal = false;
            //   this.displayModal = false;
            //   this.viewMode = false;
            //   this.$toast.add({
            //     severity: "success",
            //     summary: "Амжилттай хадгалагдсан",
            //     detail: "",
            //     life: 3000,
            //   });
            // }
          }
        }
      } else if (type == "view") {
        this.IsFocus = false;
        this.viewEdit = false;
        this.viewMode = true;
        this.contractDisabled = 1;
        this.disabled = 1;
        this.modalTitle = "Гэрээ хэвлэх горим";
        this.khoroosItem = this.defualtkhoroos;
        this.contractId = data.Id;
        this.name = data.Name;
        this.parentsName = data.ParentsName;
        this.registerNumber = data.RegisterNumber;
        this.selectedKhoroo = this.khoroosItem.filter(function (khoroo) {
          return khoroo.value.match(data.Khoroo);
        })[0];
        this.selectedDistrict = this.districtsItem.filter(function (district) {
          return district.value.match(data.District);
        })[0];
        this.apartment = data.Apartment;
        this.door = data.Door;
        this.workPlace = data.WorkPlace;
        this.position = data.Position;
        this.phoneNumber = data.PhoneNumber;
        this.phoneNumber2 = data.PhoneNumber2;
        this.email = data.Email;
        this.relateWho = data.RelateWho;
        this.relateName = data.RelateName;
        this.relateEmail = data.RelateEmail;
        this.relateRegisterNumber = data.RelateRegisterNumber;
        this.relatePhoneNumber = data.RelatePhoneNumber;
        this.billCycleDate = data.CreatedDate;
        this.selectedPackage = this.packagesItem.filter(function (tmp) {
          return tmp.Id.match(data.PackageId);
        })[0];
        this.selectedOrder = this.orderServicesItem.filter(function (order) {
          return order.Id.match(data.OrderServiceId);
        })[0];
        this.selectedProduct = this.productsItem.filter(function (product) {
          return product.type.match(data.ProductType);
        })[0];
        this.displayModal = true;
        this.productsChildrenItem = this.contractProducts.filter(function (product) {
          return product.ContractId.match(data.Id);
        });

        if(this.productsChildrenItem.length > 0)
          this.isSelectedProduct = true;
        else
          this.isSelectedProduct = false;
        
        this.blockedTable = true;

      } else if (type == "edit") {
        this.isChoseDistrict = false;
        this.IsFocus = false;
        this.viewEdit = true;
        this.viewMode = false;
        this.contractDisabled = 1;
        this.disabled = 0;
        this.modalTitle = "Гэрээ засварын горим";
        this.contractId = data.Id;
        this.name = data.Name;
        this.parentsName = data.ParentsName;
        this.registerNumber = data.RegisterNumber;
        this.selectedKhoroo = this.khoroosItem.filter(function (khoroo) {
          return khoroo.value.match(data.Khoroo);
        })[0];
        this.selectedDistrict = this.districtsItem.filter(function (district) {
          return district.value.match(data.District);
        })[0];
        this.apartment = data.Apartment;
        this.door = data.Door;
        this.workPlace = data.WorkPlace;
        this.position = data.Position;
        this.phoneNumber = data.PhoneNumber;
        this.phoneNumber2 = data.PhoneNumber2;
        this.email = data.Email;
        this.relateWho = data.RelateWho;
        this.relateName = data.RelateName;
        this.relateEmail = data.RelateEmail;
        this.relateRegisterNumber = data.RelateRegisterNumber;
        this.relatePhoneNumber = data.RelatePhoneNumber;
        this.displayModal = true;
        if(this.productsChildrenItem.length > 0)
          this.isSelectedProduct = true;
        else
          this.isSelectedProduct = false;
        
        this.blockedTable = true;

      } else if (type == "update") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        } else {
          const res = await axios.put(baseURL + "/" + this.contractId, {
            name: this.name,
            parentsName: this.parentsName,
            registerNumber: this.registerNumber,
            district: this.selectedDistrict.value,
            khoroo: this.selectedKhoroo.value,
            apartment: this.apartment,
            door: this.door,
            workPlace: this.workPlace,
            position: this.position,
            phoneNumber: this.phoneNumber,
            phoneNumber2: this.phoneNumber2,
            email: this.email,
            relateWho: this.relateWho,
            relateName: this.relateName,
            relateEmail: this.relateEmail,
            relateRegisterNumber: this.relateRegisterNumber,
            relatePhoneNumber: this.relatePhoneNumber,
            packageId: this.selectedPackage.Id,
            orderServiceId: this.selectedOrder.Id,
            productType: this.selectedProduct.type,
          });

          if (res.status == 201) {
            const resData = await axios.get(baseURL);
            this.contracts = resData.data;
            this.modal = false;
            this.displayModal = false;
            this.viewMode = false;
            this.$toast.add({
              severity: "warn",
              summary: "Амжилттай шинэчлэгдсэн",
              detail: "" + this.contractId + "",
              life: 3000,
            });
          }
        }
      } else if (type == "print") {
        // print contract send data as a json format
        await axios
          .post("https://localhost:44343/api/doc", {
            FileTemplatePath: "C:\\Users\\Dell\\Desktop\\Doc\\Template.docx",
            FileSavePath:
              "C:\\Users\\Dell\\Desktop\\Doc\\Contract- " +
              this.contractId +
              ".docx",
            ContractId: this.contractId,
            Name: this.name,
            ParentsName: this.parentsName,
            RegisterNumber: this.registerNumber,
            District: this.selectedDistrict.value,
            Khoroo: this.selectedKhoroo.value,
            Apartment: this.apartment,
            Door: this.door,
            workPlace: this.workPlace,
            Position: this.position,
            PhoneNumber: this.phoneNumber,
            PhoneNumber2: this.phoneNumber2,
            Email: this.email,
            RelateWho: this.relateWho,
            RelateName: this.relateName,
            RelateEmail: this.relateEmail,
            RelateRegisterNumber: this.relateRegisterNumber,
            RelatePhoneNumber: this.relatePhoneNumber,
            BillCycleDate: this.billCycleDate,
          })
          .then((response) => {
            if (response.data == "Success") {
              this.displayModal = false;
              this.$toast.add({
                severity: "info",
                summary: "Амжилттай хэвлэсэн",
                detail:
                  "C:\\Users\\Dell\\Desktop\\Doc\\Contract-" +
                  this.contractId +
                  ".docx",
                life: 3000,
              });
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      } else this.displayModal = false;
    },
  },
};
</script>